import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public state$: BehaviorSubject<NavigationState> = new BehaviorSubject<NavigationState>(NavigationState.Closed);
  
  constructor() { }

  // toggle the navigation state
  public toggleNavigation(): void {
    console.log('Toggling navigation state');
    const currentState = this.state$.value;
    const newState = currentState === NavigationState.Open ? NavigationState.Closed : NavigationState.Open;
    this.state$.next(newState);
  }

  public openNavigation(): void {
    console.log('Opening navigation');
    this.state$.next(NavigationState.Open);
  }

  public closeNavigation(): void {
    console.log('Closing navigation');
    this.state$.next(NavigationState.Closed);
  }

}

// definition of navigation state enum (open, closed)
export enum NavigationState {
  Open = 'open',
  Closed = 'closed'
}
